import { UserRoleAction } from "./action";
import { userRoleList, userRoleState } from "./state";

export function userRoleReducer(
    state: userRoleState = userRoleList,
    action: UserRoleAction
): userRoleState {
    switch (action.type) {
        case "@@UserRole/initUserRoleAction":
            return {
                ...state,
                roleList: action.roleList,
            };
        default:
            return state;
    }
}
